export default {
  general: {
    transparent: "transparent",
    black: "black",
  },
  brand: {
    purple: "#CC50A9",
    purpleDark: "#652B6E",
    blue: "#38D4E1",
    yellow: "#FFC933",
    yellowDark: "#FFAB19",
    magenta: "#CC50A9",
    magentaDark: "#AF257D",
    green: "#47C873",
    darkGreen: "#1FAA38",
    red: "#FB5638",
    redDark: "#F8271B",
    warning: "#FF0000",
    gray: "#4C515B",
    grayMid: "#B9B9B9",
    grayLow: "#F5F5F5",
    gray3: "#848484",
    white: "#FFFFFF",
  },
  tiles: {
    background: {
      highlighted: "#38D4E0",
      inactive: "#707070",
      active: "#4c525c",
    },
    audio: {
      tint: "#FFC932",
    },
    spelling: {
      tint: "#848484",
    },
  },
};
